import { render, staticRenderFns } from "./NoItemsToShow.vue?vue&type=template&id=1a664cd0&"
import script from "./NoItemsToShow.vue?vue&type=script&lang=js&"
export * from "./NoItemsToShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports